import { ImageUpload } from '@gameday/react-components/components/ImageUpload'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import defaultImg from '../../../assets/images/profile_default_logo.png'
import { download, upload } from '../../../functions/documents'

const StyledImageUpload = styled.div`
  .image-upload .edit-button {
    color: var(--custom-primary-color);
  }
`

function Component({
  onChange = () => {},
  formData,
  required,
  value,
  errorText,
  name,
  id,
  isToolTip,
  toolTipText,
  question,
}) {
  const [hasImage, setHasImage] = useState(false)
  const [profileImg, setProfileImg] = useState(undefined)
  const [isUploading, setIsUploading] = useState(false)
  const [fileUploadError, setFileUploadError] = useState(undefined)

  const objectName = question.name
    /* eslint-disable-next-line prefer-arrow-callback */
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
    .replace(/\s+/g, '')

  useEffect(() => {
    if (value) {
      download({
        file: value,
        info: {
          loggedInUser: formData.userId || 'not specified',
          objectId: formData.profileId,
          objectName: objectName === 'profileImage' ? 'memberProfile' : objectName,
          component: formData.pageName || 'Image Download',
          formId: formData.form,
          action: 'download',
          target: question.name,
          funcName: 'ImageDownload',
          application: formData.application,
        },
        url: formData.downloadEndpoint,
      }).then(response => {
        setProfileImg(response)
        setHasImage(true)
      })
    }
  }, [value])

  return (
    <StyledImageUpload>
      <ImageUpload
        id={id}
        label={question.name || 'Profile Image'}
        imageTypeLabel={hasImage ? 'Edit Image' : 'Add Image'}
        defaultImage={defaultImg}
        isRequired={required}
        avatarSrc={profileImg}
        avatarSize="large"
        name={name}
        onChange={data => {
          setIsUploading(true)
          upload({
            file: data.file,
            info: {
              loggedInUser: formData.userId || 'not specified',
              objectId: formData.profileId,
              objectName,
              component: formData.pageName || 'Image Upload',
              formId: formData.form,
              action: 'upload',
              target: question.name,
              funcName: 'ImageUpload',
              isImage: true,
              application: formData.application,
            },
            url: formData.uploadEndpoint,
          })
            .then(response => {
              onChange(response.key)
              setProfileImg(data.data)
              setHasImage(true)
              setIsUploading(false)
            })
            .catch(err => {
              setIsUploading(false)
              setFileUploadError(err.toString())
            })
        }}
        onDelete={() => {
          onChange(undefined)
          setProfileImg(undefined)
          setHasImage(false)
        }}
        isUploading={isUploading}
        errorText={fileUploadError || (errorText ? `${question.name} is required` : null)}
        isToolTip={isToolTip}
        toolTipText={toolTipText}
      />
    </StyledImageUpload>
  )
}

export default Component
